<template>
    <div class="Summary">
        <div class="row">
            <div class="col col-md-4">
                <h4>Child Info</h4>
                <p><span class="bold">Name: </span><span>{{ ChildRecordData.Person.FirstName }}</span> <span v-if="ChildRecordData.Person.AKA">"{{ ChildRecordData.Person.AKA }}"</span> <span>{{ ChildRecordData.Person.LastName }}</span></p>
                <p><span class="bold">DOB: </span><span>{{ formatDate(ChildRecordData.Person.DOB, 'MM/DD/YY') }}</span></p>
                <p><span class="bold">Age: </span><span>{{ ChildRecordData.Person.AgeString }}</span></p>
                <p><span class="bold">Sex: </span><span>{{ ChildRecordData.Person.Sex.Name }}</span></p>
            </div>
            <div class="col col-md-4">
                <h4>Current Placement</h4>
                <div v-if="ChildRecordData.ResidenceName != null">
                    <p><span class="bold">{{ ChildRecordData.ResidenceName }}</span></p>
                </div>
            </div>
            <div class="col col-md-4">
                <h4>Program Enrollment</h4>
                <p><span class="bold">Regional Program: </span><span>{{ ChildRecordData.SubProgramName }}</span></p>
                <p><span class="bold">Placement Agency: </span><span>{{ ChildRecordData.PlacementAgencyName }} </span></p>
                <p><span class="bold">Start Date: </span><span>{{ formatDate(ChildRecordData.ClientProgramMembership.StartDate, 'MM/DD/YY') }}</span></p>
                <p><span class="bold">End Date: </span><span>{{ formatDate(ChildRecordData.ClientProgramMembership.EndDate, 'MM/DD/YY', 'Present') }}</span></p>
            </div>
            <div class="col col-md-4">
                <h4>Primary Therapist</h4>
                <div v-if="ChildRecordData.PrimaryTherapistName != null">
                    <p><span class="bold">Name: </span><span>{{ ChildRecordData.PrimaryTherapistName }}</span></p>
                </div>
                <div v-else>
                    <p><span class="bold">None Assigned </span><span></span></p>
                </div>
            </div>
            <div class="col col-md-4">
                <h4>School</h4>
                <p><span class="bold">{{ ChildRecordData.CurrentSchools }}</span></p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'ChildRecordData'
        ],
        methods: {
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },

        },
        components: {
        },
        mounted() {

        },
        computed: {
        }
    }
</script>

<style scoped>
</style>